var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.822,
    height: 13,
    viewBox: "0 0 11.822 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete",
    d: "M7.051,3.385a.569.569,0,0,1,.4-.167H9.809a.569.569,0,0,1,.569.569v.569H6.884V3.787A.569.569,0,0,1,7.051,3.385Zm-1.385.971V3.787A1.787,1.787,0,0,1,7.453,2H9.809A1.788,1.788,0,0,1,11.6,3.787v.569h2.336a.609.609,0,0,1,0,1.219h-.569v7.638A1.788,1.788,0,0,1,11.576,15H5.686A1.788,1.788,0,0,1,3.9,13.213V5.575H3.329a.609.609,0,1,1,0-1.219Zm-.548,8.856V5.575h7.028v7.638a.569.569,0,0,1-.569.569H5.686a.569.569,0,0,1-.569-.569ZM7.453,7.3a.609.609,0,0,1,.609.609v3.534a.609.609,0,0,1-1.219,0V7.911A.609.609,0,0,1,7.453,7.3Zm2.966.609a.609.609,0,0,0-1.219,0v3.534a.609.609,0,1,0,1.219,0Z",
    transform: "translate(-2.72 -2)",
    fill: "#333",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7a155fae302f579f7d37a14cb1dc4eca.svg";
export { ForwardRef as ReactComponent };